import "./HeritageSection.css";

import {
  FaAward,
  FaUsers,
  FaHandsHelping,
  FaGem,
} from "react-icons/fa";

const HeritageSection = () => {
  return (
    <section className="heritage">

      <div className="container">

        <div className="heritage-title">

          <span>OUR HERITAGE</span>

          <h2>
            Every Thread Has
            <br />
            A Story To Tell
          </h2>

        </div>
      </div>

    </section>
  );
};

export default HeritageSection;